

<div class="content-block dx-card responsive-paddings">
  <div class="form-avatar">
    <div class="dx-icon dx-icon-user"></div>
  </div>
  <h2>{{ userResponse?.name }}</h2>
</div>

<div class="content-block dx-card responsive-paddings">
  <dx-form id="form"
    [formData]="employee"
    labelLocation="top"
    [colCountByScreen]="colCountByScreen"
  >
    <dxi-item dataField="Name" editorType="dxTextBox">
      <dxo-label text="{{ 'Name' | translate }}"></dxo-label>
    </dxi-item>
    <dxi-item dataField="LastName" editorType="dxTextBox">
      <dxo-label text="{{ 'Surname' | translate}}"></dxo-label>
    </dxi-item>
  </dx-form>
</div>